export default __webpack_public_path__ + "media/images/logo-symbol-icon-acdeba8b026df34e998a37a2084a913a.svg";